/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AsCodeConditionDto = {
    kind: AsCodeConditionDto.kind;
};

export namespace AsCodeConditionDto {

    export enum kind {
        AND_GROUP = 'andGroup',
        OR_GROUP = 'orGroup',
        EQUALS = 'equals',
        NOT_EQUALS = 'notEquals',
        GREATER_THAN = 'greaterThan',
        GREATER_THAN_OR_EQUALS = 'greaterThanOrEquals',
        LESS_THAN = 'lessThan',
        LESS_THAN_OR_EQUALS = 'lessThanOrEquals',
        IS_NULL = 'isNull',
        IS_NOT_NULL = 'isNotNull',
        CONTAINS = 'contains',
        NOT_CONTAINS = 'notContains',
        DATE_OLDER_THAN = 'dateOlderThan',
        DATE_YOUNGER_THAN = 'dateYoungerThan',
        IS_TRUE = 'isTrue',
        IS_FALSE = 'isFalse',
    }


}
